export default {
  title: "Troll",
  content: [
    "New ability: Da Voodoo Shuffle: Reduces the duration of all movement impairing effects by 15%. Trolls be flippin' out mon!",
    "Troll Regeneration now restores 1% health every 10 seconds.",
  ],
};
